import React, { ReactElement } from "react";
import { ProjectTask } from "./ProjectTask";
import { ProjectTaskChecklist } from "./ProjectTaskChecklist";
import { ProjectTaskChecklistElement } from "./ProjectTaskChecklistElement";

interface IProps {
	task: ProjectTask;
}

export const ProjectTaskChecklistList = (props: IProps): ReactElement => {
	const { task } = props;

	if (task.checklists.length === 0) {
		return <></>;
	}

	const checklists = task.checklists.map(
		(checklist: ProjectTaskChecklist, index: number) => {
			return (
				<ProjectTaskChecklistElement
					key={index}
					checklist={checklist}
					task={task}
				/>
			);
		},
	);

	return <div className="project-task-checklist">{checklists}</div>;
};
